
export function formTilmelding(){
    let forms = document.querySelectorAll('.js-tilmelding');


    if(!forms){
        return;
    }

    delegate_event('click', document, '.city', function(item){
        let data = JSON.parse(document.querySelector('.js-choice').value)[item.target.value],
            content_container = document.querySelector('.information__container'),
            btn = document.querySelector('.js-tilmelding a.button');

        content_container.innerHTML = '';
        content_container.classList.remove('hide__container');

        content_container.innerHTML = `
        <div class="price">DKK ${data.price},-</div>
            <div>
                <h4>Varighed:</h4>
                ${data.period}
            </div>
            <div>
                <h4>Tilmeldingsfrist:</h4>
                ${data.tilmeldingsfrist}
            </div>
            <div>
                <h4>Uddannelsessted:</h4>
                ${data.school} <br>
                ${data.place}
            </div>
            <div>
                <h4>Undervisningsform:</h4>
                ${data.undervisningsform}
            </div>
            <div>
                <h4>Adresse:</h4>
                ${data.postcode} ${data.city}
            </div>
            <div>
                <h4>Kontakt:</h4>
                ${data.contact_person}
            </div>
            <div>
                <h4>Telefon:</h4>
                <a href="tel:0045${data.phone}">+45 ${twoSpaceNumber(data.phone)}</a>
            </div>
            <div>
                <h4>E-mail:</h4>
                <a href="mailto:${data.email}">${data.email}</a>
            </div>
        `

        btn.classList.remove('btn-disabled');
        btn.setAttribute('href', data.url)
    })

}

function delegate_event(event_type, ancestor_element, target_element_selector, listener_function)
{
    ancestor_element.addEventListener(event_type, function(event)
    {
        if (event.target && event.target.matches && event.target.matches(target_element_selector))
        {
            (listener_function)(event);
        }
    });
}

function twoSpaceNumber(num) {
    return num.replace(/\d{2}(?!$)/g, "$& ");
}